const styles = () => ({
  root: {},
  stickyHeader: {
    position: "sticky",
    zIndex: 3,
    top: 0,
  },
});

export default styles;
